<script>
import Spinner from './Icons/Spinner.vue';
import Skeleton from 'primevue/skeleton';

export default {
  components: { Skeleton, Spinner },

  inject: {
    bayhiveSkeletonLoaders: {
      default: false,
    },
  },

  props: {
    className: {
      type: String,
      default: 'text-center mt-3 mb-3 loading',
    },
  },
};
</script>

<template>
  <div :class="className">
    <div
      v-if="bayhiveSkeletonLoaders"
      class="bayhive-embedded-content-skeleton"
      role="status"
      aria-live="polite"
      aria-label="Loading content"
    >
      <Skeleton width="100%" height="var(--p-bayhive-skeleton-text-height)" />
      <Skeleton width="86%" height="var(--p-bayhive-skeleton-text-height)" />
      <Skeleton width="72%" height="var(--p-bayhive-skeleton-text-height)" />
    </div>
    <Spinner v-else size="3x" />
  </div>
</template>

<style scoped>
.bayhive-embedded-content-skeleton {
  display: grid;
  gap: var(--p-bayhive-spacing-sm);
  text-align: left;
  width: 100%;
}
</style>
